module.exports = __webpack_public_path__ + "static/focusParalane-86c036868cd9e450ae5b494daef717b7.mp4";